import appEnv from 'app-env';
import { createLogger } from '@helu/core';
import {
  getWindowLocationEnvironment,
  isProductionEnvironment,
} from './env/env.util';

const logger = createLogger({
  areConsoleLogsEnabled: !isProductionEnvironment(),
  clientToken: appEnv.LOGGING_CLIENT_TOKEN,
  env: getWindowLocationEnvironment(),
  forwardConsoleLogs: undefined,
  forwardErrorsToLogs: true,
  isMonitoringEnabled: appEnv.LOGGING_ENABLED,
  isMonitoringWithoutTraceIdEnabled: appEnv.LOGGING_WITHOUT_TRACE_ID_ENABLED,
  service: 'main-app',
  site: 'datadoghq.eu',
  version: __APP_VERSION__,
});

export { logger };
